<template>
  <div class="w-full h-full bg-white rounded-lg">
    <div class="flex items-center w-full h-full overflow-auto">
      <div class="relative flex flex-nowrap items-center w-full min-w-full">
        <div v-for="metric in metrics" :key="metric" class="w-1/4 min-w-1/4 px-4 py-2">
          <RollupStandard :metric="metric" :data-source="dataSource" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RollupStandard from "@/components/shared/rollup-metrics/RollupStandard.vue"

export default {
  components: {
    RollupStandard
  },
  inject: ["canUserEditLayout"],
  props: {
    view_by: {
      type: Array,
      default: null
    },
    dataSource: {
      type: String,
      default: null
    }
  },
  emits: ["update:preservedFilters", "cancel"],
  data() {
    return {
      metrics: [],
      standard_metrics: [
        {
          title: this.$t("Plans"),
          options: [this.$t("Total count"), this.$t("Total pending"), this.$t("Total in progress"), this.$t("Total completed")],
          selected_option: "Total count",
          references: [
            "company_plans_total_count_rs",
            "company_plans_total_pending_rs",
            "company_plans_total_in_progress_rs",
            "company_plans_total_completed_rs"
          ],
          reference_name: "company_plans_total_count_rs",
          type: "plan",
          count: 0
        },
        {
          title: this.$t("Goals"),
          options: ["Total count", "Total pending", "Total in progress", "Total completed"],
          selected_option: "Total count",
          references: [
            "company_goals_total_count_rs",
            "company_goals_total_pending_rs",
            "company_goals_total_in_progress_rs",
            "company_goals_total_completed_rs"
          ],
          reference_name: "company_goals_total_count_rs",
          type: "goal",
          count: 0
        },
        {
          title: this.$t("Tasks"),
          options: ["Total count", "Total pending", "Total in progress", "Total completed"],
          selected_option: "Total count",
          references: [
            "company_tasks_total_count_rs",
            "company_tasks_total_pending_rs",
            "company_tasks_total_in_progress_rs",
            "company_tasks_total_completed_rs"
          ],
          reference_name: "company_tasks_total_count_rs",
          type: "task",
          count: 0
        },
        {
          title: this.$t("Interactions"),
          options: ["Total count"],
          selected_option: "Total count",
          references: ["company_interactions_total_count_rs"],
          reference_name: "company_interactions_total_count_rs",
          type: "interaction",
          count: 0
        },
        {
          title: this.$t("Meetings"),
          options: ["Total count"],
          selected_option: "Total count",
          references: ["company_meetings_total_count_rs"],
          reference_name: "company_meetings_total_count_rs",
          type: "meeting",
          count: 0
        },
        {
          title: this.$t("Emails"),
          options: ["Total count"],
          selected_option: "Total count",
          references: ["company_emails_total_count_rs"],
          reference_name: "company_emails_total_count_rs",
          type: "email",
          count: 0
        },
        {
          title: this.$t("Calls"),
          options: ["Total count"],
          selected_option: "Total count",
          references: ["company_calls_total_count_rs"],
          reference_name: "company_calls_total_count_rs",
          type: "call",
          count: 0
        }
      ]
    }
  },
  created() {
    this.metrics = this.standard_metrics.filter((metric) => this.view_by.includes(metric.type))
  }
}
</script>
